import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "@/pages/Landing";
import Registry from "@/pages/Registry";
import Docs from "@/pages/Docs";
import { Privacy, Terms } from "@/pages/Legal";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/registry" element={<Registry />} />
            <Route path="/docs" element={<Docs />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
